import { render, staticRenderFns } from "./LocalFilter.vue?vue&type=template&id=f7f45c78&scoped=true"
import script from "./LocalFilter.vue?vue&type=script&lang=js"
export * from "./LocalFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7f45c78",
  null
  
)

export default component.exports